const Termos = {
  termosPrivacidade: process.env.REACT_APP_MS_TERMOS_POLITICA_PRIVACIDADE,
  termosCondicoes: process.env.REACT_APP_MS_TERMOS_CONDICOES,
  termosSCR: process.env.REACT_APP_MS_TERMOS_SCR,
};

export default Termos;
